export default __webpack_public_path__ + "locales/pt-BR/FilesSettings.json?hash=a76404046a79229a1d1599d9116fc2df";